export default {
  async getAccountServices() {
    const promise = new Promise((resolve, reject) => {
      setTimeout(
        () =>
          resolve([
            { id: 1, name: 'fleet-management' },
            { id: 2, name: 'live-tracking' },
            { id: 3, name: 'reports' }
          ]),
        200
      )
    })
    const services = await promise

    return services
  }
}
